import { polarClient } from "@polar-sh/better-auth/client";
import { adminClient, organizationClient, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { getApiBaseUrl } from "./apiBaseUrl";
import { clubAc, clubPluginRoles, platformAc, platformPluginRoles } from "./permissions";

export const authClient = createAuthClient({
  baseURL: getApiBaseUrl(),
  plugins: [
    adminClient({
      ac: platformAc,
      roles: platformPluginRoles,
    }),
    organizationClient({
      ac: clubAc,
      roles: clubPluginRoles,
    }),
    twoFactorClient({
      onTwoFactorRedirect() {
        window.location.href = "/2fa";
      },
    }),
    polarClient(),
  ],
});

export const { useSession, signIn, signUp, signOut, useActiveOrganization, useListOrganizations } =
  authClient;

export type AppSessionUser = {
  id: string;
  name: string;
  emailVerified: boolean;
  email?: string;
  image?: string | null;
  avatarUrl?: string | null;
  slug?: string;
  bio?: string | null;
  status?: "online" | "offline" | "in_game" | "in_queue";
  lastOnlineAt?: Date | string | null;
  bannerCropData?: string | null;
  bannerUrl?: string | null;
  bannerSourceUrl?: string | null;
  isPublic?: boolean;
  onboardingCompletedAt?: Date | string | null;
  createdAt?: Date | string;
  updatedAt?: Date | string;
};
